<template>
    <div class="wrap client-list-wrap">
        <div class="top-header">
            <incBack></incBack>
            <h3>고객 / 코칭 일지</h3>
        </div>
        <div class="body-wrap">
            <incMenuShot></incMenuShot>
            
            <div class="coaching-list">
                <div class="coaching">
                    <ul>
                        <li class="clear more" @click="coachingDetail(item.sessionIdx)" v-for="(item,index) in list" :key="index">
                            <div class="w-80per float-left">
                                <div>
                                    <span>{{item.sessiontType}}</span>
                                    <h1>{{item.userName}}</h1>
                                </div>
                                <p class="date">{{item.startDate}}  {{item.startTime}}~{{item.endTime}}&nbsp;&nbsp;|&nbsp;&nbsp;<b class="bold">{{item.sessionPer}}/{{item.courseOneperson}}</b></p>
                            </div>
                            <div class="w-20per float-left">
                                <p class="state" :class="{'active':item.sessionStatus=='코칭완료'}">{{item.sessionStatus}}</p>
                            </div>
                        </li>
                        <!-- <li class="clear more" @click="coachingDetail()">
                            <div class="w-80per float-left">
                                <div>
                                    <span>화상</span>
                                    <h1>김소연</h1>
                                </div>
                                <p class="date">2021.08.10  09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;<b class="bold">2/10</b></p>
                            </div>
                            <div class="w-20per float-left">
                                <p class="state active">코칭 완료</p>
                            </div>
                        </li> -->
                    </ul>
                </div>
            </div>

            <incTab></incTab>
        </div>
    </div>
</template>
<script>
    import incBack from "@/components/inc/inc_back.vue";
    import incTab from "@/components/inc/inc_tab.vue";
    import incMenuShot from "@/components/inc/inc_menu_shot.vue";
    import dayjs from 'dayjs'
    export default {
        name: 'client_detail',
        props:{
            userIdx:{
                type:[Number,String],
                default:0
            }
        },
        data: () => ({
            list:[]
        }),
        components: {
            incBack,
            incTab,
            incMenuShot
        },
        mounted() {
            this.getClientDetail();
        },
        methods: {
            getClientDetail(){
                let params = {
                    userIdx : this.userIdx
                }
                this.axios.get("/front/coarching/user/detail",{params}).then((res)=>{
                    if(res.data.success){
                        this.list = res.data.data;
                        for(let item of this.list){
                            item.startTime = dayjs(item.startDatetime).format("HH:mm");
                            item.endTime = dayjs(item.endDatetime).format("HH:mm");
                            item.startDate = dayjs(item.startDatetime).format("YYYY.MM.DD");
                        }
                        console.log(this.list);
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            },
            coachingDetail(sessionIdx){
                this.$router.push({name:"coaching_detail",params:{sessionIdx:Number(sessionIdx)}})
            }
        }
    }
</script>